import { request } from '@/utils/request'
import { COMMON_API } from './registry'

/**
 * 公共接口 —— 对应旧 common.js 的 getSystemConfigFun / getMenu /
 * getCitiesByProvince / getAreasByCity / getTraderList / getPileList / getGunList
 */

/** 下拉项，旧工程统一返回 { value, label } */
export interface Option {
  value: string
  label: string
}

/** 系统配置（旧 getSystemConfigFun） */
export interface SystemConfigDto {
  domainName: string
  domainUrl: string
  logo: string
  copyRight: string
  officialAccounts: string
  pcMaintenancSwitch: string
}

export function getSystemConfigApi() {
  return request<{ systemSettingDto: SystemConfigDto }>(COMMON_API.systemConfig).then(
    (r) => r?.systemSettingDto ?? ({} as SystemConfigDto)
  )
}

/* ------------------------------- 菜单 ------------------------------- */

/** 后端菜单节点，字段沿用旧 /getMenu 返回结构 */
export interface MenuClassNode {
  menuClassName: string
  menuList: Array<{
    id: string
    menuName: string
    menuUrl: string
    menuPhotoId: string
    defaultJumpMenuId?: string
  }>
}

export function getMenuApi() {
  return request<MenuClassNode[]>(COMMON_API.getMenu)
}

/* ------------------------------ 省市区 ------------------------------ */

export function getProvincesApi() {
  return request<Option[]>(COMMON_API.provinces)
}

export function getCitiesApi(provinceId: string | number) {
  return request<Option[]>(COMMON_API.cities, { provinceId })
}

export function getAreasApi(cityId: string | number) {
  return request<Option[]>(COMMON_API.areas, { cityId })
}

/* --------------------------- 商户 / 桩 / 枪 --------------------------- */

/** 旧 getTraderList(controlId, flag, value) */
export function getTradersApi(params?: Record<string, any>) {
  return request<Option[]>(COMMON_API.traders, params)
}

/** 旧 getPileList：/piles?id={pileGroupId} */
export function getPilesApi(pileGroupId?: string | number) {
  return request<Option[]>(COMMON_API.piles, { id: pileGroupId })
}

/** 旧 getGunList：/guns?id={pileId} */
export function getGunsApi(pileId?: string | number) {
  return request<Option[]>(COMMON_API.guns, { id: pileId })
}

/* ------------------------------ 首页告警 ------------------------------ */

/** 旧 index.js getFault() */
export function getNewFaultApi() {
  return request<any[]>('/faultmanage/newFault')
}

export function getFaultCountApi() {
  return request<any[]>('/faultmanage/getFaultCount')
}

export function getFaultAllCountApi() {
  return request<number>('/faultmanage/getFaultAllCount')
}

/** 旧 index.js getUnReadMessageFun() */
export function getUnReadMessageApi() {
  return request<any[]>('/appraisemanage/getUnReadMessage')
}

export function getUnReadCountApi() {
  return request<number>('/messagemanage/getUnReadCount')
}
